import { render, staticRenderFns } from "./FocusPersonInput.vue?vue&type=template&id=6288d082&scoped=true"
import script from "./FocusPersonInput.vue?vue&type=script&lang=js"
export * from "./FocusPersonInput.vue?vue&type=script&lang=js"
import style0 from "./FocusPersonInput.vue?vue&type=style&index=0&id=6288d082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6288d082",
  null
  
)

export default component.exports